import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import Constants from '../../../definitions/constants';
import TableDescriptors from '../../../definitions/tableDescriptors';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import FormatTooling from '../../../tooling/formatTooling';
import EntityTableTooling from '../../../tooling/entityTableTooling';
import LocaleTooling from '../../../tooling/localeTooling';
import { intl } from '../../../locales/localesConfig';
import toastr, { version } from 'toastr';

/* Actions */
import * as endpointsConnectorsPanelActions from '../../actions/endpointsConnectorsPanel/index';
import * as dashboardActions from '../../actions/dashboard/index';

/*Components*/
import FullScreenGlassLoading from '../../components/common/interface/fullScreenGlassLoading';
import EntityHeader from '../../components/common/entity/entityHeader';
import EntityTable from '../../components/common/entity/entityTable';
import GlassConfirmPopup from '../../components/common/interface/glassConfirmPopup';
import EntityUseQuery from '../entityUseQuery';
import Select from '../../components/common/inputs/select';
import LastUpdatesListPopup from '../../components/endpointsConnectorsPanel/lastUpdatesListPopup';
import CalculationUnitsFilter from '../../components/endpointsConnectorsPanel/calculationUnitsFilter';
import ErrorLoadingView from '../../components/common/interface/errorLoadingView';

const popupIds = {
  manualUpdateConfirmPopup: "manualUpdateConfirmPopup",
  lastUpdatesListPopup: "lastUpdatesListPopup"
}

const calculationUnitsFilterInitialState = {
  filterGroup: "",
  criteria: Constants.calculationFilters.calculationUnitFilter.ALL,
  calculationUnitsSelected: [],
  polynomial_id: "",
  reprocess_criteria: Constants.selectKeys.endpoint.reprocess_criteria.only_reprocess
};

class EndpointsConnectorsPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      topControlsFormData: {
        searchText: '',
        periodIdSelected: '',
      },
      calculationUnitsFilters: JavascriptUtilsTooling.deepCopy(calculationUnitsFilterInitialState),
      searchTimeoutObject: null,
      entityApiKey: "endpoint_connector_panel",
      tableDescriptor: TableDescriptors.endpointsConnectorsPanelList,
      activeConnectorId: "",
      activeConnectorType: "",
      activeConnectorMetricValuesIterateCalculationUnits: null,
    };
  }
 
  async componentDidMount() {
    await this.props.actions.getPeriodsList();
    await this.props.actions.getPolynomialsList();
  }
  
  componentWillUnmount() {
    this.props.actions.reset();
  }
  
  componentDidUpdate(prevProps) {
    if (this.props.periodsList.status===200 && prevProps.periodsList.status !==200) {
      if(this.props.periodsList.data.length > 0) {
        let periodIdSelected = this.props.periodsList.data[0].id;
        let selectedPeriod = null;
        if(this.props.match.params.periodId) {
          selectedPeriod = this.props.periodsList.data.find(item => item.id==this.props.match.params.periodId);
          periodIdSelected = selectedPeriod ? selectedPeriod.id : null;
        }
        if(this.props.fixedPeriodId!="") {
          selectedPeriod = this.props.periodsList.data.find(item => item.id==this.props.fixedPeriodId);
          periodIdSelected = selectedPeriod ? selectedPeriod.id : null;
        }
        this.state.topControlsFormData.periodIdSelected = periodIdSelected;
        this.props.actions.setPeriodId(periodIdSelected);
        this.props.actions.getGroupsList(periodIdSelected);
        EntityTableTooling.fetchList(this);
      }
    }

    InterfaceTooling.apiCallResultFeedback(
      [prevProps.runConnector.status],
      [this.props.runConnector.status],
      intl.formatMessage({ id: "endpointsConnectorsPanel.successRunningConnector" }),
      this.props.runConnector.status==409 ?
        intl.formatMessage({ id: "endpointsConnectorsPanel.errors.connectorAlreadyRunning" }) :
        (this.props.runConnector.status==423 ?
          intl.formatMessage({ id: "common.errors.systemLockedError" }) :
          intl.formatMessage({ id: "endpointsConnectorsPanel.errors.runningConnector" })),
      [async () => {
        if(InterfaceTooling.popupHasToRender(this.state[popupIds.manualUpdateConfirmPopup])) {
          InterfaceTooling.popupHide(popupIds.manualUpdateConfirmPopup, this.setState.bind(this));
        }
        this.setState({
          activeConnectorId: ""
        }); 
      }]
    );
  }

  getListQueryParams(defaultQueryParams) {
    let newQueryParams = defaultQueryParams;
    newQueryParams.fields_are = [];
    newQueryParams.searches_are = [];
    newQueryParams.active = !this.state.topControlsFormData.showDisabledEntities ? true : false;
    newQueryParams.period_id = this.state.topControlsFormData.periodIdSelected;
    return newQueryParams;
  }

  handleShowRunConnectorManuallyConfirmPopup = (event) => {
    InterfaceTooling.handleShowPopup(
      event, popupIds.manualUpdateConfirmPopup, this.state, 
      this.setState.bind(this), this.props.runConnector.loading, () => {       
        let entityData = event.currentTarget.dataset.entitydata ? JSON.parse(event.currentTarget.dataset.entitydata) : {};
        this.setState({
          activeConnectorId: entityData.id,
          activeConnectorType: entityData.endpoint_connector_type,
          activeConnectorMetricValuesIterateCalculationUnits: entityData.connector_metric_values_iterate_calculation_units,
          calculationUnitsFilters: JavascriptUtilsTooling.deepCopy(calculationUnitsFilterInitialState)
        });
      }      
    );
  }

  handleRunConnectorManually = async () => {
    let runParams = {
      endpoint_connector_id: this.state.activeConnectorId,
      period_id: this.state.topControlsFormData.periodIdSelected
    }
    let selectedPeriod = this.props.periodsList.data.find(item => item.id==this.state.topControlsFormData.periodIdSelected);
    let periodState = selectedPeriod ? selectedPeriod.state : ""; 
    if(this.state.activeConnectorType == Constants.selectKeys.endpoint.endpoint_connector_type.output_export_calculation_units_reports_endpoint_type ||
      this.state.activeConnectorType == Constants.selectKeys.endpoint.endpoint_connector_type.output_export_calculation_units_calculations_endpoint_type ||
      (this.state.activeConnectorType == Constants.selectKeys.endpoint.endpoint_connector_type.metric_values_endpoint_type &&
        this.state.activeConnectorMetricValuesIterateCalculationUnits)) {
      runParams["execution_calculation_units_params"] = {
        group_id: this.state.calculationUnitsFilters.filterGroup,       
        calculation_units_criteria: this.state.calculationUnitsFilters.criteria,
        calculation_units: this.state.calculationUnitsFilters.calculationUnitsSelected
      } 
    }
    if((this.state.activeConnectorType == Constants.selectKeys.endpoint.endpoint_connector_type.output_export_calculation_units_reports_endpoint_type ||
      this.state.activeConnectorType == Constants.selectKeys.endpoint.endpoint_connector_type.output_export_calculation_units_calculations_endpoint_type) &&
      periodState == "reprocess"
    ) {
      runParams["execution_calculation_units_params"]["reprocess_criteria"] = this.state.calculationUnitsFilters.reprocess_criteria;
    }
    if(this.state.activeConnectorType == Constants.selectKeys.endpoint.endpoint_connector_type.output_export_calculation_units_calculations_endpoint_type) {
      runParams["execution_calculation_units_params"]["polynomial_id"] = this.state.calculationUnitsFilters.polynomial_id;
    }
    await this.props.actions.runConnector(runParams)
  }

  handleShowLastUpdatesListPopup = (event) => {
    InterfaceTooling.handleShowPopup(
      event, popupIds.lastUpdatesListPopup, this.state, 
      this.setState.bind(this), this.props.lastUpdatesList.loading, () => {
        let entityData = event.currentTarget.dataset.entitydata ? JSON.parse(event.currentTarget.dataset.entitydata) : [];
        let connectorId = entityData.id;
        let periodId = this.state.topControlsFormData.periodIdSelected;
        this.props.actions.getLastUpdates(connectorId, periodId);        
        this.setState({
          activeConnectorId: entityData.id
        });
      });
  };

  handleRefreshLastUpdatesListPopup = () => {
    this.props.actions.getLastUpdates(this.state.activeConnectorId, this.state.topControlsFormData.periodIdSelected);
  }

  handleLoadDataInfoPopupNextPage = async (event) => {
    var page = +event.currentTarget.dataset.targetpage;
    if(this.props.lastUpdatesList.status === 200 && 
       this.props.lastUpdatesList.page<=this.props.lastUpdatesList.totalPages) {
      await this.props.actions.getLastUpdates(this.state.activeConnectorId, this.state.topControlsFormData.periodIdSelected, page);
    }  
  };

  handleOnChangeCalculationUnitsFilters = (event) => {
    let path = event.currentTarget.dataset.path;
    let value = this.state.calculationUnitsFilters[path];
    let calculationUnitsFiltersNew = JavascriptUtilsTooling.deepCopy(this.state.calculationUnitsFilters);
    
    if(event.currentTarget.dataset.selectlist) {
      let index = event.currentTarget.dataset.index;
      let listValue = event.currentTarget.value;
      let isDelete = event.currentTarget.dataset.delete;
      
      let calculation_units = calculationUnitsFiltersNew[path]
            
      if(isDelete) { 
        delete calculation_units[index];
        calculation_units = calculation_units.filter(item => item);
      } else {
        var selectedItem = this.props.calculationUnitsFilter.data.find(item => item.id==listValue);
        var exists = this.state.calculationUnitsFilters.calculationUnitsSelected.find(item => item.id==listValue);
        if(selectedItem && !exists) {
          calculation_units.push({id: listValue, name: selectedItem.name });
        }
        else if(exists) {
          toastr.options = Constants.interface.tostrOptions;
          toastr.warning(LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage( {id: "periodAdmin.calculationUnitAlreadyAdded"})),""); 
        }
      }
      value = calculation_units;
    }
    else {
      value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    }
    calculationUnitsFiltersNew[path] = value;
    
    if((path=="criteria" && value==Constants.calculationFilters.calculationUnitFilter.ALL) ||
      (path=="filterGroup" && value!="" && value!=this.state.calculationUnitsFilters.filterGroup)) {
        calculationUnitsFiltersNew.calculationUnitsSelected = [];
    }
    
    this.setState({
      calculationUnitsFilters: calculationUnitsFiltersNew
    });    
  };

  handleFetchFilterCalculationUnits = async (keyword) => {
    await this.props.actions.getCalculationUnitsList(keyword, 
      this.state.calculationUnitsFilters.filterGroup,
      this.state.topControlsFormData.periodIdSelected);
  };

  handleOnChangeTopControls = (event) => {
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    EntityTableTooling.handleOnChangeTopControls(this, event);
    if(event.currentTarget.id == "periodIdSelected") {
      this.props.actions.getGroupsList(value);
    }
  };

  render() {
    var loadingView = this.props.periodsList.firstLoading || this.props.polynomialsList.firstLoading || (
      (this.props.list.firstLoading || this.props.groupsFilter.firstLoading || this.props.groupsFilter.loading) && 
        this.props.periodsList.status == 200 && this.props.periodsList.data.length>0);
    var errorLoadingView = (this.props.periodsList.status !== null && this.props.periodsList.status !== 200) ||
        (this.props.list.status !== null && this.props.list.status !== 200) ||
        (this.props.groupsFilter.status !== null && this.props.groupsFilter.status !== 200) ||
        (this.props.polynomialsList.status !== null && this.props.polynomialsList.status !== 200);
    var noPeriodsCreated = this.props.periodsList.status == 200 && this.props.periodsList.data.length==0;
    return (      
      <section className="dashboard_content_inner_view entity_admin_container endpoints_connectors_panel_container">
        {
          loadingView ? (<FullScreenGlassLoading/>) :
          noPeriodsCreated ? (
            <section>
              <EntityHeader 
                entityNamePlural={this.state.tableDescriptor.entityNamePlural}
                entityNameSingular={this.state.tableDescriptor.entityNameSingular}
              />
              <div className="no_period_selected_wrapper">
                {intl.formatMessage({ id: "common.noPeriodCreated" })}
              </div>
            </section>            
          ) : 
          errorLoadingView ? (<ErrorLoadingView/>) :          
          (
            <section>
              <EntityHeader 
                alternativeTitle={intl.formatMessage({id: "endpointsConnectorsPanel.headerTitle"})}
                handleRefresh={EntityTableTooling.fetchList.bind(null, this)}
              />
              <div className="endpoints_connectors_panel_container_legend">
                <div className="legend_item">
                  <div className="legend_item_color legend_item_color_green"></div>
                  <div className="legend_item_text">
                    <FormattedMessage id="endpointsConnectorsPanel.legendItem.success"/>
                  </div>
                </div>
                <div className="legend_item">
                  <div className="legend_item_color legend_item_color_yellow"></div>
                  <div className="legend_item_text">
                    <FormattedMessage id="endpointsConnectorsPanel.legendItem.success_with_errors"/>
                  </div>
                </div>
                <div className="legend_item">
                  <div className="legend_item_color legend_item_color_white"></div>
                  <div className="legend_item_text">
                    <FormattedMessage id="endpointsConnectorsPanel.legendItem.pending"/>
                  </div>
                </div>
                <div className="legend_item">
                  <div className="legend_item_color legend_item_color_grey"></div>
                  <div className="legend_item_text">
                    <FormattedMessage id="endpointsConnectorsPanel.legendItem.processing"/>
                  </div>
                </div>
                <div className="legend_item">
                  <div className="legend_item_color legend_item_color_red"></div>
                  <div className="legend_item_text">
                    <FormattedMessage id="endpointsConnectorsPanel.legendItem.failure"/>
                  </div>
                </div>
              </div>
              <EntityTable
                entityTableDescriptor={this.state.tableDescriptor}
                data={this.props.list.data}
                loading={this.props.list.loading}
                page={this.props.list.page}
                totalPages={this.props.list.totalPages}
                totalRecords={this.props.list.totalRecords}
                orderBy={this.props.list.orderBy}
                orderByDirection={this.props.list.orderByDirection}
                topControlsFormData={this.state.topControlsFormData}
                disableDisbledEntitiesControl={true}
                handleOnChangeTopControls={this.handleOnChangeTopControls}
                fetchOrderList={EntityTableTooling.fetchListOrder.bind(null, this)}
                fetchListChangePage={EntityTableTooling.fetchListNextPage.bind(null, this)}
                handleCustomActions={[this.handleShowRunConnectorManuallyConfirmPopup, this.handleShowLastUpdatesListPopup]}
                customActionsIcons={["play", "list"]}
                customActionsTooltips={[
                  intl.formatMessage({ id: "endpointsConnectorsPanel.manualConnectorUpdateTitle"}),
                  intl.formatMessage({ id: "endpointsConnectorsPanel.lastUpdatesListTitle"}),
                ]}
                extraControls={
                  <div>
                    <Select 
                      className="top_controls_period_selected"
                      disabled={this.props.fixedPeriodId!=""}
                      id="periodIdSelected"
                      value={this.state.topControlsFormData.periodIdSelected}
                      onChange={this.handleOnChangeTopControls}
                      labelLocale={<FormattedMessage id="common.periodSelectLabel"/>}
                      options={InterfaceTooling.getSelectArrayFromArrayOfObjects(this.props.periodsList.data, "id", "name", false)}
                    />
                  </div>
                }
                colorConfig={[{
                  color: "green",
                  column: "process_state",
                  value: Constants.endpointConnectorPanel.endpoint_connector_processing_states.SUCCESS
                },{
                  color: "red",
                  column: "process_state",
                  value: Constants.endpointConnectorPanel.endpoint_connector_processing_states.FAILURE
                },{
                  color: "yellow",
                  column: "process_state",
                  value: Constants.endpointConnectorPanel.endpoint_connector_processing_states.SUCCESS_WITH_ERRORS
                },{
                  color: "grey",
                  column: "process_state",
                  value: Constants.endpointConnectorPanel.endpoint_connector_processing_states.PROCESSING
                }]}
              />
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage id={"endpointsConnectorsPanel.manualConnectorUpdateTitle"} />)}
                confirmText={(<FormattedMessage id={"endpointsConnectorsPanel.manualConnectorUpdateConfirmText"} />)}
                handleConfirm={this.handleRunConnectorManually}
                handleCancel={this.handleShowRunConnectorManuallyConfirmPopup}
                popupState={this.state[popupIds.manualUpdateConfirmPopup]}
                loading={this.props.runConnector.loading}
              >
                {(this.state.activeConnectorType == Constants.selectKeys.endpoint.endpoint_connector_type.output_export_calculation_units_reports_endpoint_type ||
                  this.state.activeConnectorType == Constants.selectKeys.endpoint.endpoint_connector_type.output_export_calculation_units_calculations_endpoint_type ||
                  (this.state.activeConnectorType == Constants.selectKeys.endpoint.endpoint_connector_type.metric_values_endpoint_type &&
                    this.state.activeConnectorMetricValuesIterateCalculationUnits)
                ) ? (
                  <CalculationUnitsFilter
                    onChangeFilter={this.handleOnChangeCalculationUnitsFilters}
                    filterValues={this.state.calculationUnitsFilters}
                    connectorType={this.state.activeConnectorType}
                    selectedPeriod={this.props.periodsList.data.find(item => item.id==this.state.topControlsFormData.periodIdSelected)}
                    groupsData={this.props.groupsFilter.data}
                    calculationUnitsData={this.props.calculationUnitsFilter.data}
                    calculationUnitsLoading={this.props.calculationUnitsFilter.loading}
                    calculationUnitsFetchAction={this.handleFetchFilterCalculationUnits}
                    modelsData={this.props.polynomialsList.data}
                  />
                ) : null}
              </GlassConfirmPopup>
              <LastUpdatesListPopup
                handleShowPopup={this.handleShowLastUpdatesListPopup}
                handleRefresh={this.handleRefreshLastUpdatesListPopup}
                fullLoading={this.props.lastUpdatesList.firstLoading}
                tableLoading={this.props.lastUpdatesList.loading}
                listState={this.props.lastUpdatesList}
                handleNextPage={this.handleLoadDataInfoPopupNextPage}
                popupState={this.state[popupIds.lastUpdatesListPopup]}
                handleRowClick={this.props.handleNotificationDetailPopupReference}
              />
            </section>
          )
        }
      </section>
    );
  }
}

const mapStateToProps = state => ({
  list: state.reducer.endpointsConnectorsPanel.list,
  runConnector: state.reducer.endpointsConnectorsPanel.runConnector,
  periodsList: state.reducer.endpointsConnectorsPanel.periodsList,
  periodId: state.reducer.endpointsConnectorsPanel.periodId,
  fixedPeriodId: state.reducer.dashboard.fixedPeriodId,
  lastUpdatesList: state.reducer.endpointsConnectorsPanel.lastUpdatesList,
  calculationUnitsFilter: state.reducer.endpointsConnectorsPanel.calculationUnitsFilter,
  groupsFilter: state.reducer.endpointsConnectorsPanel.groupsFilter,
  polynomialsList: state.reducer.endpointsConnectorsPanel.polynomialsList,
  handleNotificationDetailPopupReference: state.reducer.dashboard.handleNotificationDetailPopupReference,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(endpointsConnectorsPanelActions, dispatch),
  dashboardActions: bindActionCreators(dashboardActions, dispatch)
});

EndpointsConnectorsPanel.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EndpointsConnectorsPanel);



// WEBPACK FOOTER //
// ./source/client/containers/endpointsConnectorsPanel/index.jsx